import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import MethylationDetoxificationOverviewCombined from "./index";

const MethylationDetoxificationOverviewWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={MethylationDetoxificationOverviewCombined}
    keyControlsId="methylation-detoxification-overview-key"
    {...props}
  />
);

export default MethylationDetoxificationOverviewWithToggleKey;
